<template>
    <span v-tooltip.top="formattedBrand" class="icon is-card" :class="[size ? size : '']">
        <i :class="`card-${icon}`" />
    </span>
</template>

<script>
import Cards from 'mixins/cards';

export default {
    mixins: [Cards],

    props: {
        size: { type: [String, Boolean], default: 'is-small' },
        brand: { type: String, required: true },
    },

    computed: {
        formattedBrand() {
            return this.cardDropdownBrand(this.brand);
        },

        icon() {
            return this.cardDropdownBrandIcon({ brand: this.brand });
        },
    },
};
</script>
